/**
 * Detects if WebGL is available and functional in the current environment.
 * WebGL can fail in: VMs, remote desktop, disabled hardware acceleration,
 * too many contexts, privacy extensions, or restricted browsers.
 */
export function isWebGLSupported(): boolean {
  if (typeof document === 'undefined') return false;
  try {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl') ?? canvas.getContext('experimental-webgl');
    return !!gl;
  } catch {
    return false;
  }
}
